module.exports = __webpack_public_path__ + "static/media/mail.23a7dee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail.svg
// module id = 115
// module chunks = 0